"use client"
import {
  Badge,
  Card,
  Divider,
  LogoutButton,
  NavigationItem,
} from "@/components/atoms"
import { usePathname } from "next/navigation"
import { useTranslate } from "@tolgee/react"
import { useChat } from "@/context/ChatContext"

const navigationItems = [
  {
    key: "orders",
    href: "/user/orders",
  },
  {
    key: "messages",
    href: "/user/messages",
  },
  {
    key: "returns",
    href: "/user/returns",
  },
  {
    key: "addresses",
    href: "/user/addresses",
  },
  {
    key: "reviews",
    href: "/user/reviews/product",
  },
  {
    key: "wishlist",
    href: "/user/wishlist",
  },
  {
    key: "affiliate_program",
    href: "/user/affiliatex",
  },
]

export const UserNavigation = () => {
  const { unreadMessageCount: unreads } = useChat()
  const path = usePathname()
  const { t } = useTranslate()

  return (
    <Card className="bb-user-nav h-min">
      <nav className="bb-user-nav-list flex flex-col gap-0.5">
        {navigationItems.map((item) => {
          const active =
            path.endsWith(item.href) ||
            (item.key === "reviews" && path.includes("/user/reviews")) ||
            (item.key === "orders" && path.includes("/user/orders")) ||
            (item.key === "affiliate_program" &&
              path.includes("/user/affiliatex"))

          return (
            <NavigationItem
              key={item.key}
              href={item.href}
              active={active}
              className={`bb-user-nav-item relative ${
                active ? "bb-user-nav-item--active" : ""
              }`}
            >
              <span className="bb-user-nav-label">
                {t(`user_navigation.${item.key}`)}
              </span>
              {item.key === "messages" && Boolean(unreads) && (
                <Badge className="absolute top-2.5 right-3 w-4 h-4 p-0">
                  {unreads}
                </Badge>
              )}
            </NavigationItem>
          )
        })}
      </nav>
      <Divider className="bb-user-nav-divider my-3" />
      <NavigationItem
        href="/user/settings"
        active={path.includes("/user/settings")}
        className={`bb-user-nav-item ${
          path.includes("/user/settings") ? "bb-user-nav-item--active" : ""
        }`}
      >
        <span className="bb-user-nav-label">
          {t("user_navigation.settings")}
        </span>
      </NavigationItem>
      <LogoutButton className="bb-user-nav-logout w-full text-left" />
    </Card>
  )
}
